import IvrBotPage from "@/app/ivr/pages/IvrBotPage.vue";
import ListTemplate from "@/app/ivr/bot/components/templates/ListTemplate.vue";
import DetailTemplate from "@/app/ivr/bot/components/templates/DetailTemplate.vue";

export default [
  {
    path: "/flows/ivr-automatic",
    component: IvrBotPage,
    children: [
      {
        path: "",
        component: ListTemplate,
      },
      {
        path: ":id",
        name: "edit-bot",
        component: DetailTemplate,
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/flows/ivr-survey",
    component: IvrBotPage,
    children: [
      {
        path: "",
        component: ListTemplate,
      },
      {
        path: ":id",
        component: DetailTemplate,
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];
